<div class="link">
  <button
    type="button"
    class="btn btn-link btn-link--{{ color() }} text-start focus-border-large {{ isTextUnderlined() ? 'text-decoration-underline' : '' }}"
    (click)="actionClicked.emit()"
    [attr.data-test]="dataTest()"
  >
    @if (icon()) {
      <i class="pr-1 fas fa-{{ icon() }} {{ iconMarginClass() }}"></i>
    }
    {{ text() | translate }}
  </button>
</div>
